import styled from "styled-components";

export const Container = styled.div`
  .action-btn {
    display: flex;
    align-items: center;
    gap: 20px;
    svg {
      cursor: pointer;
    }
    .round-btn {
      background: linear-gradient(
        180deg,
        #d9d9d9 0%,
        rgba(217, 217, 217, 0) 100%
      );
      border: 1px solid #636f7c;
      border-radius: 6px;
      width: 30px;
      height: 26.36px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const Heading = styled.div`
  min-height: 48px;
  padding: 12px 5px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-bottom: 1px solid #d1d0cb;
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 150.5%;
    color: var(--text-primary);
  }
  p {
    font-size: 14px;
    color: #000000b3;
  }
`;

export const BoxContainer = styled.div`
  margin-bottom: 24px;
`;

export const WorkSection = styled.div`
  background: #ffffff;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
  label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  .select-wrapper {
    .select {
      margin-bottom: 10px;
      margin-top: 4px;
    }
    label {
      font-size: 13px;
      color: #1d1d1d;
    }
    .MuiFormControl-root {
      margin: 0;
      width: 100%;
    }
    .MuiSelect-select {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      font-size: 13px;
      padding: 2.5px 10px;
    }
  }
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 22px;
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  label {
    margin: 0;
  }
  &.no-side-border {
    ::after {
      display: none;
    }
  }
  
  .cloud-icon {
    position: absolute;
    top: 7px;
    right: 10px;
  }
  .checkbox {
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    min-width: 270px;
    min-height: 30px;
  }
  .MuiCheckbox-root {
    padding: 0;
    padding-right: 5px;
  }
  .MuiTypography-root {
    font-size: 13px;
    white-space: normal;
    padding-right: 30px;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
  }
`;

export const TextAreaBox = styled.div`
  position: relative;
  margin-bottom: 40px;
  textarea {
    width: 100%;
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding: 10px;
    max-width: 100%;
    min-width: 100%;
  }
  label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  span {
    position: absolute;
    color: #1d1d1d99;
    font-size: 11px;
    right: 0;
    bottom: -10px;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  button {
    font-size: 13px;
    line-height: 150.5%;
    color: #1d1d1d;
    padding: 5px 10px;
    border: 1px solid #636f7c;
    border-radius: 30px;
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: #fff;
    font-family: "latoregular";
    &.reset-btn {
      border: none;
      text-decoration: underline;
    }
  }
`;

export const TimeOut = styled.div`
  padding: 13px 0;
  label {
    font-size: 13px;
    color: #1d1d1d;
    min-width: 96px;
    display: inline-flex;
  }
  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    max-width: 46px;
    height: 30px;
    margin: 0 6px 0 24px;
    display: inline-flex;
  }
  span {
    color: #6c6c6c;
    font-size: 12px;
  }
`;

export const StartEndDate = styled.div`
  position: relative;
  width: max-content;
  .label {
    font-size: 13px;
    color: #1d1d1d;
    margin-bottom: 4px;
  }
  .MuiInputLabel-root {
    display: none;
  }
  fieldset {
    display: none;
  }
  input {
    max-height: 30px;
    padding: 0 10px;
    margin: 0;
    font-size: 13px;
    max-width: 120px;
  }
  .time-icon {
    position: absolute;
    right: 9px;
    bottom: 8px;
  }
`;
export const UnlockModeWrapper = styled.div`
  margin-bottom: 22px;
`;

export const UnlockMode = styled.div`
  border: 1px solid #82dbcf;
  border-radius: 6px;
  display: flex;
  align-items: center;
  width: max-content;
  button {
    height: 30px;
    color: #1d1d1dcc;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    min-width: 64px;
    padding: 0 11px;
    &.active {
      background: #82dbcf;
      border-radius: 6px;
      font-weight: 700;
      color: #1d1d1d;
    }
  }
`;
